module.exports = __webpack_public_path__ + "img/curecancer.4c5ce65.png";